var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.83268V5.66602C4.5 3.73518 5.08333 2.16602 8 2.16602C10.9167 2.16602 11.5 3.73518 11.5 5.66602V6.83268",
    stroke: "#7A7A7A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 11.7917C8.8055 11.7917 9.45842 11.1387 9.45842 10.3333C9.45842 9.52792 8.8055 8.875 8.00008 8.875C7.19467 8.875 6.54175 9.52792 6.54175 10.3333C6.54175 11.1387 7.19467 11.7917 8.00008 11.7917Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9167 13.834H5.08341C2.75008 13.834 2.16675 13.2507 2.16675 10.9173V9.75065C2.16675 7.41732 2.75008 6.83398 5.08341 6.83398H10.9167C13.2501 6.83398 13.8334 7.41732 13.8334 9.75065V10.9173C13.8334 13.2507 13.2501 13.834 10.9167 13.834Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.a6a3cd3dc591f8b6b0533b5ca679d187.svg";
export { ForwardRef as ReactComponent };